import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const PlayGroundIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "PlayGroundIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M20.5121 18.4842H19.0304C18.7957 18.4842 18.5843 18.3448 18.4919 18.129L17.1983 15.1107C16.5512 13.6007 15.0714 12.6249 13.4285 12.6249H12.817V7.93754H13.4029C13.9368 7.93754 14.1934 7.27626 13.7958 6.91692L8.52254 2.15144C8.29946 1.94984 7.95993 1.94984 7.73684 2.15144L2.46356 6.91692C2.06587 7.27629 2.32262 7.93754 2.85641 7.93754H3.44234V20.8278H2.85641C2.53282 20.8278 2.27048 21.0901 2.27048 21.4137C2.27048 21.7373 2.53282 21.9996 2.85641 21.9996H4.02824C4.35183 21.9996 4.61417 21.7373 4.61417 21.4137V18.4841H5.786V21.4137C5.786 21.7373 6.04834 21.9996 6.37193 21.9996C6.69552 21.9996 6.95786 21.7373 6.95786 21.4137V20.8278H9.30156V21.4137C9.30156 21.7373 9.5639 21.9996 9.88749 21.9996C10.2111 21.9996 10.4734 21.7373 10.4734 21.4137V18.4841H11.6452V21.4137C11.6452 21.7373 11.9076 21.9996 12.2312 21.9996H13.403C13.7266 21.9996 13.9889 21.7373 13.9889 21.4137C13.9889 21.0901 13.7266 20.8278 13.403 20.8278H12.8171V16.1404H13.6348C13.8695 16.1404 14.0809 16.2798 14.1733 16.4955L15.7712 20.2241C16.2335 21.3027 17.2905 21.9997 18.464 21.9997H20.5122C21.4814 21.9997 22.27 21.2111 22.27 20.2419C22.2699 19.2704 21.4837 18.4841 20.5121 18.4842ZM5.78596 17.3123H4.61413V16.1405H5.78596V17.3123ZM9.30148 19.656H6.95778V18.4842H9.30148V19.656ZM9.30148 17.3123H6.95778V16.1405H9.30148V17.3123ZM11.6452 17.3123H10.4733V16.1405H11.6452V17.3123ZM11.6452 14.9686H4.61413V7.93757H11.6452V14.9686ZM4.37859 6.76571L8.12966 3.37589L11.8807 6.76571H4.37859ZM20.5121 20.8278H18.4638C17.7597 20.8278 17.1256 20.4096 16.8482 19.7625L15.2503 16.0339C14.9729 15.3868 14.3387 14.9686 13.6347 14.9686H12.817V13.7968H13.4285C14.602 13.7968 15.659 14.4938 16.1212 15.5724L17.4148 18.5907C17.6921 19.2379 18.3263 19.656 19.0304 19.656H20.5121C20.8359 19.656 21.098 19.918 21.098 20.2419C21.098 20.565 20.8352 20.8278 20.5121 20.8278Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.12966 9.1094C6.83736 9.1094 5.78596 10.1608 5.78596 11.4531C5.78596 12.7454 6.83732 13.7968 8.12966 13.7968C9.422 13.7968 10.4734 12.7454 10.4734 11.4531C10.4734 10.1608 9.42196 9.1094 8.12966 9.1094ZM8.12966 12.6249C7.48349 12.6249 6.95783 12.0992 6.95783 11.4531C6.95783 10.807 7.48353 10.2813 8.12966 10.2813C8.77583 10.2813 9.30149 10.807 9.30149 11.4531C9.30149 12.0992 8.77583 12.6249 8.12966 12.6249Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default PlayGroundIcon;
